import React from 'react';

export default function PhotoTile({ photo }) {
  if (photo.url) {
    return (
      <div
        className="portal-photo-tile"
        style={{ backgroundImage: `url(${photo.url})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        {photo.label && <span className="portal-photo-label">{photo.label}</span>}
      </div>
    );
  }
  const bg = `linear-gradient(135deg, hsl(${photo.h}, ${photo.s}%, ${photo.l}%), hsl(${photo.h}, ${photo.s + 15}%, ${photo.l + 12}%))`;
  return (
    <div className="portal-photo-tile" style={{ background: bg }}>
      <span className="portal-photo-label">{photo.label}</span>
    </div>
  );
}
